export default __webpack_public_path__ + "static/media/marine.415f4c9f.png";